export default __webpack_public_path__ + "static/media/paypal.a5a2cc2f.svg";